import React from "react";
import moment from "moment";
import {
  Button,
  Input,
  Form,
  FormGroup,
  Label,
  Col,
  Row,
  Card,
  CardBody,
  Table,
  DropdownItem
} from "reactstrap";
import NumericInput from 'react-numeric-input';
import toastr from 'COMPONENTS/ShowTostr/ShowTostr';
import Spinner from "COMPONENTS/Spinner/Spinner";
import Switch from "COMPONENTS/CommonComponents/Switch/Switch";
// import HeaderContainer from "../Header/HeaderContainer";

// Utilities
import { checkIfValidImageFile, isAlphaNumeric, hasWhiteSpace } from "UTILS/Utility";
import { getFormatedDate, getTomorrowDate, isValidDate } from "UTILS/DateUtils";

// Daterangepicker
import 'react-dates/initialize';
import { SingleDatePicker } from 'react-dates';

// Images
import ic_audio from "ASSETS/Images/header_center/ic_audio_deactivate.svg";
import ic_pdf from "ASSETS/Images/pdf/ic_pdf.svg";
import ic_canvas from "ASSETS/Images/header_center/ic_canvas_deactivate.svg";
import ic_message from "ASSETS/Images/header_center/ic_message_deactivate.svg";
import ic_video from "ASSETS/Images/header_center/ic_video_deactivate.svg";
import ic_share from "ASSETS/Images/header_center/ic_share_deactivate.svg";
import ic_location from "ASSETS/Images/header_center/ic_location_deactivate.svg";
import ic_camera from "ASSETS/Images/header_center/ic_snapshot_deactivate.svg";
import ic_admin_co_browse from "ASSETS/Images/header_center/ic_co_browse_deactivate.svg";
import ic_inbound_cobrowse from "ASSETS/Images/header_center/ic_inbound_co_browse_deactivate.svg";

import ic_QR_code from "ASSETS/Images/ic_QR_code.svg";
import download_img from "ASSETS/Images/ic_download_allow.svg";
import ic_error from "ASSETS/Images/ic_error.svg";
import ic_edit from "ASSETS/Images/ic_edit.svg";
import ic_add_storage from "ASSETS/Images/ic_add_storage.svg";
import ic_app_emulation from "ASSETS/Images/ic_app_emulation_small.svg";

// Strings
import { getMessage } from "CONFIG/i18n";
import { modulesAvailableConstant, cobrowseTypes, modulesToDisplay, LOG_TYPE, STORAGE_LOCATION, BUSINESS_MODELS } from "../../../Utils/Constants";
import { validateNumber } from "UTILS/regexValidations";

import "../Organisations/AddOrganization.less";
import "../../App/App.less";
import 'react-dates/lib/css/_datepicker.css';
import "./../Organisations/Organisations.less";

import { APP_CONFIG, STORAGE } from "UTILS/Constants";
import { addLeadingSlash } from "history/PathUtils";

class EditOrganization extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orgid: this.props.editOrganisationData.id,
      name: this.props.editOrganisationData.name,
      seats: this.props.editOrganisationData.seats,
      businessModel: this.props.editOrganisationData.businessModel,
      maxConcurrentConnections: this.props.editOrganisationData.maxConcurrentSessions,
      qr_limit: this.props.editOrganisationData.qr_limit,
      availableModules: this.props.editOrganisationData.modules,
      firstName: this.props.editOrganisationData.firstName,
      lastName: this.props.editOrganisationData.lastName,
      username: this.props.editOrganisationData.username,
      uriIdentifier: this.props.editOrganisationData.uriIdentifier,
      loggingLevel: this.props.editOrganisationData.loggingLevel,
      storage: {
        storageDetails: this.props.editOrganisationData?.storageDetails ? _.cloneDeep(this.props.editOrganisationData.storageDetails) : {}
      },
      recordingStorage: { 
        storageDetails: this.props.editOrganisationData?.recordingStorageDetails ? _.cloneDeep(this.props.editOrganisationData.recordingStorageDetails) : {}
      },
      errorMessage: "",
      licenseExpiryDate: moment(this.props.editOrganisationData.license_expiry),
      previousDate: moment(this.props.editOrganisationData.license_expiry),
      minDate: getTomorrowDate(),
      image_file: "",
      logo: this.props.editOrganisationData.logo,
      image_data: "",
      is_image_changed: false,
      tenantWording_file: "",
      tenantWording: this.props.editOrganisationData.tenantWording,
      tenantWording_data: "",
      is_tenantWording_changed: false,
      spinnerVisibility: false,
      isDataEdited: false,
      currentBucket: "",
      isSSOEnabled: this.props.editOrganisationData?.isSSOEnabled,
      isPasscodeEnabled: this.props.editOrganisationData?.isPasscodeEnabled,
      isOrganizationTemplatesEnabled: this.props.editOrganisationData?.isOrganizationTemplatesEnabled,
      showSystemCapacity: false,
      cobrowseType: this.props.editOrganisationData.cobrowseSettings?.cobrowseType ? this.props.editOrganisationData.cobrowseSettings.cobrowseType : cobrowseTypes.CUSTOMER_CO_BROWSE,
      isSMSEnabled: this.props.editOrganisationData?.isSMSEnabled,
      isMfaEnabled: this.props.editOrganisationData?.isMfaEnabled,
      noOfDevices: this.props.editOrganisationData.noOfDevices,
      coBrowseLicenseKey: this.props.editOrganisationData.cobrowse_license_key || "",
      coBrowsePrivateKey: this.props.editOrganisationData.cobrowse_private_key || "",
    };
    this.isPasting = false;
    this.uploadImageRef = null;
  }
  
  componentDidMount() {
    this.selectDefaultStorage(-1, "storage");
    this.selectDefaultStorage(-1, "recordingStorage");
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.editOrganisationData !== this.props.editOrganisationData) {
      this.setState({
        logo : this.props.editOrganisationData.logo,
        tenantWording: this.props.editOrganisationData.tenantWording
      })
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let rtn = null;
    if (nextProps.editOrganisationData?.storageDetails !== prevState.storage.storageDetails) {
      rtn = {
        ...rtn,
        storage: {
          ...prevState.storage,
          storageDetails: nextProps.editOrganisationData.storageDetails,
        }
      };
    }
    if (nextProps.editOrganisationData?.recordingStorageDetails !== prevState.recordingStorage.storageDetails) {
      rtn = { 
        ...rtn,
        recordingStorage: {
          ...prevState.recordingStorage,
          storageDetails: nextProps.editOrganisationData.recordingStorageDetails,
        }
      };
    }
    return rtn;
  }

  renderSpinner = () => {
    return <Spinner showSpinner={this.state.spinnerVisibility} />;
  }

  handleSaveClick = () => {
    let modules = this.state.availableModules; 
    if (!this.isValidData()) {
      return;
    }
    let formData = new FormData();
    formData.append("file", this.state.image_data);
    formData.append("wording", this.state.tenantWording_data);
    formData.append("customerId", this.props.editOrganisationData.id);
    let qrLimit = this.state.availableModules.indexOf("QR_CODE") != -1
      && this.state.qr_limit && this.state.qr_limit != ""
      ? this.state.qr_limit : undefined;
    let data = Object.assign(
      {},
      {
        name: this.state.name.trim(),
        seats: this.state.seats,
        maxConcurrentSessions: this.state.maxConcurrentConnections,
        businessModel: this.state.businessModel,
        availableModules: modules,
        licenseExpiryDate: this.state.licenseExpiryDate.format("YYYY-MM-DD"),
        qrLimit: qrLimit,
        status: "ACTIVE",
        loggingLevel: this.state.loggingLevel,
        uriIdentifier: this.state.uriIdentifier,
        storageDetails: this.state.storage.storageDetails,
        recordingStorageDetails: this.state.recordingStorage.storageDetails,
        isSSOEnabled: this.state.isSSOEnabled,
        language: this.props.language,
        isPasscodeEnabled: this.state.isPasscodeEnabled,
        isOrganizationTemplatesEnabled:this.state.isOrganizationTemplatesEnabled,
        cobrowseType: this.state.availableModules.includes(modulesAvailableConstant.CO_BROWSE) ? this.state.cobrowseType : null,
        isSMSEnabled: this.state.isSMSEnabled,
        isMfaEnabled: this.state.isMfaEnabled,
        coBrowseLicenseKey: (this.state.coBrowseLicenseKey || "").trim(),
        coBrowsePrivateKey: (this.state.coBrowsePrivateKey || "").trim()
      }
    );

    // below if condition added for issue no 3958
    if(navigator.onLine) {
      this.setState({ errorMessage: "" });
    }
    if (this.state.is_image_changed || this.state.is_tenantWording_changed) {
      if (this.state.is_tenantWording_changed) {
        this.props.uploadTenantWording(formData, data, this.state.is_image_changed, this.state.is_tenantWording_changed);
      }
      if (this.state.is_image_changed) {
        this.props.uploadImage(formData, data);
      }
    } else {
      if (this.state.isDataEdited) {
        this.props.handleSaveOrgClick(data, errorMessage => {
          this.setState({
            errorMessage: errorMessage,
          });
        });
      } else {
        this.resetStorageDetailsFields("storage");
        this.resetError("storage");
        this.resetStorageDetailsFields("recordingStorage");
        this.resetError("recordingStorage");
        this.props.handleCancelClick();
      }
    }
  };

  // 要件に応じて検証の順序を変更する change sequence of validation as per requirement
  isValidData = () => {
    let OrgDetail = this.state;

    if (!OrgDetail.name || !OrgDetail.name.trim()) {
      this.setState({ errorMessage: getMessage("INVALID_ORG_NAME") });
      return false;
    }
    if (!OrgDetail.licenseExpiryDate || !isValidDate(OrgDetail.licenseExpiryDate) || !getFormatedDate(OrgDetail.licenseExpiryDate.toDate())) {
      this.setState({ errorMessage: getMessage("INVALID_DATE") });
      return false;
    }
    if (OrgDetail.businessModel === BUSINESS_MODELS.NUMBER_OF_SEATS) {
      if (!OrgDetail.seats || !validateNumber(OrgDetail.seats) || OrgDetail.seats === '' || OrgDetail.seats === null || OrgDetail.seats < 1) {
        this.setState({
          errorMessage: getMessage("SEAT_ERROR_MSG")
        });
        return false;
      }
    } else if (OrgDetail.businessModel === BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS) {
      if (!OrgDetail.maxConcurrentConnections || !validateNumber(OrgDetail.maxConcurrentConnections) || 
    OrgDetail.maxConcurrentConnections === '' || OrgDetail.maxConcurrentConnections === null || 
    OrgDetail.maxConcurrentConnections < 1) {
        this.setState({
          errorMessage: getMessage("MAX_CONCURRENT_CONNECTIONS_ERROR_MSG"),
        });
        return false;
      }
    }
    if (this.state.availableModules.indexOf("QR_CODE") !== -1
      && (OrgDetail.qr_limit <= 0 || OrgDetail.qr_limit > 10  || !OrgDetail.qr_limit || !validateNumber(OrgDetail.qr_limit))) {
      this.setState({
        errorMessage: getMessage("QR_LIMIT_ERROR_MSG"),
        qr_limit: 0
      });
      return false;
    }
    if (this.state.uriIdentifier) {
      if (!isAlphaNumeric(this.state.uriIdentifier)) {
        this.setState({ errorMessage: getMessage("SPECIAL_CHARACTERS_ERROR") });
        return false;
      }
    }
    if((this.state.isPasscodeEnabled || this.state.isSSOEnabled) && _.isEmpty(OrgDetail.uriIdentifier)) {
      this.setState({ errorMessage: getMessage("EMPTY_URI_IDENTIFIER") });
      return false;
    }

    if(_.isEmpty(OrgDetail.coBrowseLicenseKey) && OrgDetail.availableModules.includes("INBOUND_CO_BROWSE")){
      this.setState({
        errorMessage: getMessage("COBROWSE_LICENSE_KEY_ERROR"),
      });
      return false;     
    }
 
    if(_.isEmpty(OrgDetail.coBrowsePrivateKey) && OrgDetail.availableModules.includes("INBOUND_CO_BROWSE")){
      this.setState({
        errorMessage: getMessage("COBROWSE_ACCESS_TOKEN_ERROR"),
      });
      return false;     
    }
    
    // if (this.state.loggingLevel == LOG_TYPE.ADVANCED
    //   && (this.state.storageDetails.location === STORAGE_LOCATION.LOOOKIT_CUSTOM && !this.state.isStorageSelected)) {
    //   this.setState({ errorMessage: getMessage("INVALID_STORAGE_OPTION") });
    //   return false;
    // }
    // if(OrgDetail.qr_limit < this.props.editOrganisationData.qr_limit){
    //   this.setState({errorMessage: getMessage("OR_LIMIT_SHOULD_GREATER_OR_EQUAL")})
    //   return false
    // }
    // recording storage validation starts
    if (this.state.recordingStorage.storageDetails?.location === STORAGE_LOCATION.LOOOKIT_CUSTOM
      && this.state.recordingStorage.storageDetails.list.length > 0) {
      let storageSelectedFlag = false;
      this.state.recordingStorage.storageDetails.list.forEach((storageDetail) => {
        if (storageDetail.isSelected) {
          storageSelectedFlag = true;
        }
      });
      if (!storageSelectedFlag) {
        this.setState((prevState) => {
          return {
            recordingStorage: {
              ...prevState.recordingStorage,
              editOrgerrorMessage: getMessage("INVALID_STORAGE_OPTION"),
            }
          };
        });
        return false;
      }
    }
    // recording storage validation ends
    // remove storage credentials list if storage location is not loookit custom  
    if(this.state.storage.storageDetails.location !== STORAGE_LOCATION.LOOOKIT_CUSTOM){
      let storageDetails = this.state.storage.storageDetails;
      storageDetails.list = [];
      this.setState({
        storage: {
          ...this.state.storage,
          storageDetails
        }
      }) 
    }
    // remove storage credentials list if storage location is not loookit custom  
    if(this.state.recordingStorage.storageDetails.location !== STORAGE_LOCATION.LOOOKIT_CUSTOM){
      let storageDetails = this.state.recordingStorage.storageDetails;
      storageDetails.list = [];
      this.setState({
        recordingStorage: {
          ...this.state.recordingStorage,
          storageDetails
        }
      }) 
    }
    return true;
  };

  handleInputChange = event => {
    if(event.target.name === "uriIdentifier" && hasWhiteSpace(event.target.value)) {
      this.setState({
        [event.target.name]: event.target.value.trim(),
        errorMessage: "",
        isDataEdited: true 
      });
    }
    else {
      if (event.target.name === 'coBrowsePrivateKey'){

        if (this.isPasting) return;
        
        if (event.target.validation !== this.state.coBrowsePrivateKey) {
          this.setState({
            coBrowsePrivateKey: event.target.value,
            errorMessage: "",
            isDataEdited: true
          });
        }
        
        return; 
      } else {
        this.setState({
          [event.target.name]: event.target.value,
          errorMessage: "",
          isDataEdited: true
        });
      }  
    }
    if (event.target.name == "licenseExpiryDate") {
      this.setState({ previousDate: event.target.value.trim() });
    }
  };

  handlePaste = event => {
    if (event.target.name == 'coBrowsePrivateKey') {
      this.isPasting = true; 
      const pastedValue = (event.clipboardData || window.clipboardData).getData('text');
      const normalized = pastedValue.replace(/\r\n/g, '\n').trimEnd(); // to make sure CRLF is converted to LF
      this.setState({ coBrowsePrivateKey: normalized, isDataEdited: true }); // add isDataEdited to tag changes happened after paste
      
      setTimeout(() => {
        this.isPasting = false;
      }, 0);
    
    }
  }
  handleNumericKeyDown = (e) => !/\d|Backspace|Delete|Arrow|Tab|Home|End/.test(e.key) && !e.ctrlKey && e.preventDefault()

  handleNumberInputChange = (name, value, maxLimit) => {
  // For seats and maxConcurrentConnections, use strict validation  
    if (name === "seats" || name === "maxConcurrentConnections") {
    // Handle empty/null values - allow clearing the field
      if (value === null || value === undefined || value === '') {
        this.setState({
          [name]: null,
          errorMessage: "",
          isDataEdited: true,
          showSystemCapacity: true
        });
        return;
      }

      // Handle zero values - show zero but not negative numbers
      if (value === 0) {
        this.setState({
          [name]: 0,
          errorMessage: "",
          isDataEdited: true,
          showSystemCapacity: true
        });
        return;
      }

      if (Number.isInteger(value) && (value < 1 || value > maxLimit)) {
        this.setState({
          [name]: this.state[name]
        });
        return;
      }

      if (Number.isInteger(value) && value >= 1 && value <= maxLimit) {
        this.setState({
          [name]: value,
          errorMessage: "",
          isDataEdited: true,
          showSystemCapacity: true
        });
      }
      return;
    }

    // For other fields (like qr_limit), use the existing logic
    if (value === null || value === undefined || value === '') {
      this.setState({
        [name]: null,
        errorMessage: "",
        isDataEdited: true,
        showSystemCapacity: true
      });
      return;
    }

    if (value === 0 && maxLimit > 0) {
      this.setState({
        [name]: null,
        errorMessage: "",
        isDataEdited: true,
        showSystemCapacity: true
      });
      return;
    }

    if (!Number.isInteger(value) || value > maxLimit) {
      this.setState({
        [name]: this.state[name]
      });
      return;
    }

    this.setState({
      [name]: value,
      errorMessage: "",
      isDataEdited: true,
      showSystemCapacity: true
    });
  }

  handleDateChange = (date) => {
    this.setState({
      licenseExpiryDate: date,
      errorMessage: "",
      isDataEdited: true
    });
  }

  changeModulePermission = event => {
    let state_element = this.state.availableModules;

    // if (event.target.name === modulesAvailableConstant.CANVAS) return;
    // console.log(event.target)
    if (event.target.checked && !(event.target.name in state_element)) {
      state_element.push(event.target.name);
    } else if (!event.target.checked) {
      state_element = _.remove(state_element, item => {
        if (item !== event.target.name) return item;
      });
    }
    this.setState(
      {
        availableModules: state_element,
        errorMessage: "",
        isDataEdited: true
      }
    );
  };

  handleOrgWordingChange = event => {
    if (event.target.files) {
      const file = event.target.files[0];
      if (!file) {
        return
      }
      this.setState({
        tenantWording: URL.createObjectURL(file),
        tenantWordingUrl: file,
        tenantWording_data: file,
        is_tenantWording_changed: true,
      });
    }
  };

  downloadOrgWording = () => {
    if(this.props.translation) {
      let downloadWordingElement = document.getElementById("downloadWordingFile");
      downloadWordingElement.href = `${this.props.wording}`;
      downloadWordingElement.download = `customer_${this.props.editOrganisationData.id}_translation.json`
    }else{
      return
    }
  };

  handleOrgLogoChange = event => {
    if (event.target.files) {
      const file = event.target.files[0];
      const fileValidationResult = checkIfValidImageFile(file);
      if (!file) {
        return
      }
      if (!fileValidationResult.valid) {
        toastr.error(fileValidationResult.error);
        return
      }
      this.setState({
        logo: URL.createObjectURL(file),
        logoUrl: file,
        image_data: file,
        is_image_changed: true
      });
    }
  };

  handleOrgWordingChange = event => {
    if (event.target.files) {
      const file = event.target.files[0];
      if (!file) {
        return
      }
      this.setState({
        tenantWording: URL.createObjectURL(file),
        tenantWordingUrl: file,
        tenantWording_data: file,
        is_tenantWording_changed: true,
      });
    }
  };

  downloadOrgWording = () => {
    if(this.props.translation) {
      let downloadWordingElement = document.getElementById("downloadWordingFile");
      downloadWordingElement.href = `${this.props.wording}`;
      downloadWordingElement.download = `customer_${this.props.editOrganisationData.id}_translation.json`
    }else{
      return
    }
  };

  isDataEdited = () => {
    if (this.props.editOrganisationData.name !== this.state.name) return true;
    if (this.props.editOrganisationData.seats !== this.state.seats) return true;
    if (this.props.editOrganisationData.maxConcurrentSessions !== this.state.maxConcurrentConnections) return true;
    if (
      this.props.editOrganisationData.license_expiry !==
      this.state.licenseExpiryDate
    )
      return true;
    if (
      !_.isEqual(
        this.state.availableModules.sort(),
        this.props.editOrganisationData.modules.sort()
      )
    )
      return true;

    return false;
  };

  displayAllModuleList = () => {
    let allModuleList = [];

    _.map(modulesToDisplay, (key, value) => {

      switch (key) {
        case "CANVAS":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="CANVAS"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.CANVAS
                  )}
                />
                <img
                  src={ic_canvas}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "AUDIO":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="AUDIO"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.AUDIO
                  )}
                />
                <img
                  src={ic_audio}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage("AUDIO")}
              </Label>
            </Col>
          );
          break;
        case "AUDIO_VIDEO":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="AUDIO_VIDEO"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.AUDIO_VIDEO
                  )}
                />
                <img
                  src={ic_video}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage("VIDEO")}
              </Label>
            </Col>
          );
          break;
        case "SCREENSHARE":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="SCREENSHARE"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.SCREENSHARE
                  )}
                />
                <img
                  src={ic_share}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "MSG":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="CHAT"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.CHAT
                  )}
                />
                <img
                  src={ic_message}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "LOCATION":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="LOCATION"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.LOCATION
                  )}
                />
                <img
                  src={ic_location}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "PDF_EDITOR":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="PDF"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.PDF
                  )}
                />
                <img
                  src={ic_pdf}
                  style={{
                    height: "17px",
                    width: "17px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "SNAP_SHOT":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="SNAPSHOT"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.SNAPSHOT
                  )}
                />
                <img
                  src={ic_camera}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "QR_CODE":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="QR_CODE"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.QR_CODE
                  )}
                />
                <img
                  src={ic_QR_code}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage("QR_CODE")}
              </Label>
            </Col>
          );
          break;
        case "ALLOW_DOWNLOAD":
          allModuleList.push(
            <Col key={key} xs={12} lg={4}>
              <Label className="label  noPadding">
                <Input
                  type="checkbox"
                  name="ALLOW_DOWNLOAD"
                  onChange={this.changeModulePermission}
                  checked={this.state.availableModules.includes(
                    modulesAvailableConstant.ALLOW_DOWNLOAD
                  )}
                />
                <img
                  src={download_img}
                  style={{
                    height: "20px",
                    width: "20px"
                  }}
                />{" "}
                {getMessage(value)}
              </Label>
            </Col>
          );
          break;
        case "CO_BROWSE":
          allModuleList.push(
            <React.Fragment key={key}>
              <Col xs={12} lg={4}>
                <Label className="label noPadding">
                  <Input
                    type="checkbox"
                    name="CO_BROWSE"
                    onChange={this.changeModulePermission}
                    checked={this.state.availableModules.includes(
                      modulesAvailableConstant.CO_BROWSE
                    )}
                  />
                  <img
                    src={ic_admin_co_browse}
                    style={{
                      height: "20px",
                      width: "20px"
                    }}
                  />{" "}
                  {getMessage("CO_BROWSE")}
                </Label>
              </Col>
              {this.state.availableModules.includes(modulesAvailableConstant.CO_BROWSE) && 
              <Col xs={12} lg={6} className="noPadding">
                <Input
                  type="select"
                  name="cobrowseType"
                  id="cobrowseType"
                  className="inputFormControl"
                  onChange={this.handleInputChange}
                  value={this.state.cobrowseType}
                >
                  <option className="inputFormControl" value={cobrowseTypes.CUSTOMER_CO_BROWSE}>{getMessage("CUSTOMER_CO_BROWSE")}</option>
                  <option className="inputFormControl" value={cobrowseTypes.CUSTOMER_CO_BROWSE_V2}>{getMessage("CUSTOMER_CO_BROWSE_V2")}</option>
                </Input>
              </Col>
              }
            </React.Fragment>
          );
          break;
        case "INBOUND_CO_BROWSE":
          allModuleList.push(
                <>
                <Col key={key} xs={12} lg={4}>
                  <Label className="label noPadding">
                    <Input
                      type="checkbox"
                      name="INBOUND_CO_BROWSE"
                      onChange={this.changeModulePermission}
                      checked={this.state.availableModules.includes(
                        modulesAvailableConstant.INBOUND_CO_BROWSE
                      )}
                    />
                    <img
                      src={ic_inbound_cobrowse}
                      style={{
                        height: "20px",
                        width: "20px"
                      }}
                    />{" "}
                    {getMessage("INBOUND_CO_BROWSE")}
                  </Label>
                </Col>
                  </>
          );
          break;
      }
    });
    return allModuleList;
  }

  resetEditState = () => {
    this.setState({
      id: this.props.editOrganisationData.id, 
      name: this.props.editOrganisationData.name,
      seats: this.props.editOrganisationData.seats,
      maxConcurrentConnections: this.props.editOrganisationData.maxConcurrentSessions,
      availableModules: this.props.editOrganisationData.modules,
      firstName: "",
      lastName: "",
      username: "",
      licenseExpiryDate: moment(this.props.editOrganisationData.license_expiry),
      previousDate: moment(this.props.editOrganisationData.license_expiry),
      minDate: getTomorrowDate(),
      image_file: this.props.editOrganisationData.logoUrl,
      logo: "",
      image_data: "",
      is_image_changed: false,
      tenantWording_file: this.props.editOrganisationData.tenantWordingURL,
      tenantWording: "",
      tenantWording_data: "",
      is_tenantWording_changed: false,
      errorMessage: "",
      editOrgerrorMessage: "",
      storageErrorMessage: "",
      qr_limit: this.props.editOrganisationData.qr_limit,
      isDataEdited: false,
      isVerified: false,
      isAddStorage: false,
      isEditStorage: false,
      bucketName: "",
      secret: "",
      storageChanged: false,
      currentBucket: "",
      cobrowseType: this.props.editOrganisationData?.cobrowseSettings?.cobrowseType
    });
  };

  handleUploadImage = () => {
    this.uploadImageRef.click();
  }

  handleUploadOrgWording = () => {
    this.uploadWordingRef.click();
  }

  renderButtons = () => {
    return (
      <div>
        <Button
          className="buttons borderBtn bgwhite"
          onClick={this.props.handleCancelClick}
        >
          {getMessage("CANCEL")}
        </Button>
        <Button onClick={this.handleSaveClick} className="buttons customBtn whiteOnClick">
          {getMessage("SAVE")}
        </Button>
      </div>
    );
  };

  handleS3InputChange = (event, targetStorage) => {
    if(!hasWhiteSpace(event.target.value)) {
      this.setState({
        [targetStorage]:{
          ...this.state[targetStorage],
          [event.target.name]: event.target.value,
          isVerified: false
        }
      },
      () => {this.resetError(targetStorage)});
    }
  }

  selectDefaultStorage = (selectedStorageDetailIndex, targetStorage) => {
    let storageDetailsList = this.state[targetStorage]?.storageDetails?.list ? this.state[targetStorage]?.storageDetails?.list.slice() : [];
    let valid = false;
    let storageState = _.cloneDeep(this.state[targetStorage]);
    if (!this.state[targetStorage].isStorageSelected && this.state.errorMessage)
      this.setState({ errorMessage: "" })
    if (selectedStorageDetailIndex != -1) {
      let newStorageDetailsList = storageDetailsList
      storageDetailsList.forEach((storageDetails, index) => {
        if (index === selectedStorageDetailIndex) {
          newStorageDetailsList[index].isSelected = true;
          valid = true;
          storageState.storageChanged = true;
          this.setState({
            isDataEdited: true
          })
        } else {
          newStorageDetailsList[index].isSelected = false;
        }
      });
      storageState.storageDetails.list = newStorageDetailsList;
    }
    else {
      storageDetailsList.forEach((storageDetails, index) => {
        if (storageDetails.isSelected) {
          valid = true;
        }
      });
    }
    this.setState({
      [targetStorage]: {
        ...storageState,
        storageErrorMessage: "",
        isStorageSelected: valid
      }
    });//storageDetails: obj
  }
  
  renderStorageDetailSetting = (targetStorage) => {
    return(
      <>
        {this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.LOOOKIT_CUSTOM &&
          <div className="section">
            <Row className="noMargin">
              <Col className="mainTitleStorage pl-0 label">{getMessage("STORAGE")}
              </Col>
              {(!this.state[targetStorage].isAddStorage && !this.state[targetStorage].isEditStorage) 
              && (this.state[targetStorage].storageDetails.location === STORAGE_LOCATION.LOOOKIT_CUSTOM) ?
                <Col className="mainTitleStorage pr-0">
                  <img 
                    src={ic_add_storage}
                    className="cursorPointer floatRight"
                    onClick={() => this.setState({
                      [targetStorage]: { 
                        ...this.state[targetStorage],
                        isAddStorage: true 
                      }
                    })}
                    data-toggle="tooltip"
                    data-placement="top"
                    title={getMessage("ADD_STORAGE")} />
                </Col>
                : null
              }
            </Row>
            <div>
              {/*show storage table when list of storageDetails is not empty */}
              {this.state[targetStorage].storageDetails?.list &&
                <Row className="storageCard">
                  <CardBody className="pt-0 pb-0">
                    <Row className="interCardContent">
                      <Table bordered size="sm" className="ml-2 mr-2 storageTableWidth">
                        <thead>
                          <tr className="storageHead">
                            <th className="storageRow border-bottom rounded"> </th>
                            <th className="storageRow border-bottom rounded" colSpan="2">{getMessage("BUCKET_NAME")}</th>
                            <th className="storageRow border-bottom rounded" colSpan="3">{getMessage("ID")}</th>
                            <th className="storageRow border-bottom rounded" colSpan="3">{getMessage("SECRET")}</th>
                            <th className="storageRow border-bottom rounded"> </th>
                            <th className="storageRow border-bottom rounded"> </th>
                          </tr>
                        </thead>
                        {this.renderStorageTableBody(targetStorage)}
                      </Table>
                    </Row>
                  </CardBody>
                </Row>
              }
              {this.state[targetStorage].isEditStorage || this.state[targetStorage].isAddStorage ?
                <Row> {/* storage input */}
                  <Col className="storageCard">
                    <Card>
                      <CardBody>
                        <Row className="radio">
                          <Col>
                            <Label className="label modal-label">{getMessage("AWS_S3")}:</Label>
                          </Col>
                          <Col>
                            {/* × button */}
                            <Button 
                              close aria-label="Cancel" 
                              onClick={() => {
                                this.cancelStorage(targetStorage);
                              }}
                            >
                            </Button>
                          </Col>
                        </Row>
                        <Row className="interCardContent">
                          <Col xs={4} className="pt-4 align-self-center">
                            <Label>{getMessage("BUCKET_NAME")}</Label> </Col>
                          <Col xs={8}>
                            <Input
                              type="text"
                              name="bucketName"
                              className="inputFormControl mt-3"
                              maxLength="63"
                              required
                              onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                              disabled={this.state[targetStorage].currentBucket} 
                              value={this.state[targetStorage].bucketName}
                            />
                          </Col>
                        </Row>
                        <Row className="interCardContent">
                          <Col xs={4} className="pt-4 align-self-center">
                            <Label>
                              {getMessage("ID")}
                            </Label>
                          </Col>
                          <Col xs={8}>
                            <Input
                              type="text"
                              name="id"
                              className="inputFormControl mt-3"
                              maxLength="50"
                              required
                              onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                              value={this.state[targetStorage].id}
                            />
                          </Col>
                        </Row>
                        <Row className="interCardContent">
                          <Col xs={4} className="pt-4 align-self-center">
                            <Label>
                              {getMessage("SECRET")}
                            </Label>
                          </Col>
                          <Col xs={8}>
                            <Input
                              type="password"
                              name="secret"
                              className="inputFormControl mt-3"
                              maxLength="50"
                              required
                              onChange={(event) => this.handleS3InputChange(event, targetStorage)}
                              value={this.state[targetStorage].secret}
                            />
                          </Col>
                        </Row>
                        {this.state[targetStorage].storageErrorMessage &&
                          <Row>
                            <Col md={12} className="errors autoHeight">
                              {getMessage(this.state[targetStorage].storageErrorMessage)}
                            </Col>
                          </Row>
                        }
                        <Row className="interCardContent floatRight">
                          <Button 
                            onClick={() => this.handleVerifyStorageDetailsClick(targetStorage)}
                            disabled={!this.state[targetStorage].isVerified ? false : true}
                            className={this.state[targetStorage].isVerified ? "verifiedBtn mt-2" : "verifyBtn mt-2"}
                          >
                            {this.state[targetStorage].isVerified ? getMessage("VERIFIED") : getMessage("VERIFY")}
                          </Button>
                          <Button
                            className={this.state[targetStorage].isVerified 
                              ? "borderBtn cursorPointer bgwhite ml-3 mt-2" 
                              : "disabledBtn ml-3 mt-2"}
                            disabled={this.state[targetStorage].isVerified ? false : true}
                            onClick={() => this.addStorage(targetStorage)}
                          >
                            {this.state[targetStorage].isEditStorage ? getMessage("UPDATE") : getMessage("ADD")}
                          </Button>
                        </Row>
                      </CardBody>
                    </Card>
                  </Col>
                </Row>
                : null}
            </div>
            {this.state[targetStorage].editOrgerrorMessage ? <Row><Col md={12} className="errors autoHeight">{getMessage(this.state[targetStorage].editOrgerrorMessage)}</Col> </Row> : null}
          </div>
        }
        {this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.LOOOKIT_CUSTOM 
        && !this.state[targetStorage].isStorageSelected && (!this.state[targetStorage].isEditStorage && !this.state[targetStorage].isAddStorage) ?
          <Row><Col md={12} className="warning autoHeight">
            {targetStorage === STORAGE.STORAGE 
              ? getMessage("FIRST_LOOOKIT_CUSTOM_WARNING")
              : getMessage("FIRST_LOOOKIT_CUSTOM_WARNING_RECORDING")}
          </Col> </Row>
          : null}
        {((this.state[targetStorage].storageDetails?.location === STORAGE_LOCATION.CUSTOMER) 
        && (!this.state[targetStorage].storageDetails?.otherStorageValid)) ?
          <Row><Col md={12} className="warning autoHeight">{getMessage("CUSTOMER_WARNING")}</Col> </Row>
          : null}
        {this.state[targetStorage].storageChanged ?
          <Row><Col md={12} className="text-muted text-center autoHeight">
            {targetStorage === STORAGE.STORAGE 
              ? getMessage("SECOND_LOOOKIT_CUSTOM_WARNING")
              : getMessage("SECOND_LOOOKIT_CUSTOM_WARNING_RECORDING")}
          </Col> </Row>
          : null
        }
      </>
    )
  }
  /**
   * storage table
   * @param {*} targetStorage 
   * @returns 
   */
  renderStorageTableBody(targetStorage) {
    return (
      <tbody>
        {this.state[targetStorage].storageDetails.list?.map((item, index) =>
          <tr className="cursorPointer" key={item.credential.id}>
            <td className="storageRow">
              <Input
                type="radio"
                className='oldRadio'
                checked={item.isSelected}
                onChange={() => this.selectDefaultStorage(index, targetStorage)}
              />
              <span className="checkmark" value={item.isSelected}
                onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              </span>
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="2"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              {item.credential.bucketName}
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="3"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              {item.credential.id}
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}
              colSpan="3"
              onClick={() => this.selectDefaultStorage(index, targetStorage)}>
              ****************************************
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}>
              {!item.validation.status ?
                <img src={ic_error} alt="Status" className="ml-2 cursorPointer"
                  id="bucketError" data-toggle="tooltip" data-placement="bottom"
                  title={item.validation.error.message} />
                : null
              }
            </td>
            <td className={item.validation?.error?.message ? "storageRowError" : "storageRow"}>
              <img src={ic_edit} alt="Edit" className="cursorPointer"
                onClick={() => { this.handleEditStorageClick(item.credential.bucketName, targetStorage) }} />
            </td>
          </tr>)
        }
      </tbody>
    )
  }

  resetStorageDetailsFields = (targetStorage) => {
    this.setState((state, props) => {
      return{
        [targetStorage]: {
          ...state[targetStorage],
          isVerified: false,
          isAddStorage: false,
          isEditStorage: false,
          bucketName: "",
          id: "",
          secret: "",
          storageChanged: false,
          currentBucket: "",
        }
      }
    });
  }

  resetError = (targetStorage) => {
    this.setState((state, props) => {
      return{
        [targetStorage]: {
          ...state[targetStorage],
          storageErrorMessage: "",
          editOrgerrorMessage: ""
        },
        errorMessage: "",
      }
    });
  }

  handleEditStorageClick(bucketName, targetStorage) {
    let bucket = null;
    if (!_.isEmpty(bucketName)) {
      bucket = this.state[targetStorage].storageDetails.list?.filter((item =>
        item.credential.bucketName === bucketName
      ))[0];
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          isEditStorage: true,
          bucketName: bucket.credential.bucketName,
          id: bucket.credential.id,
          secret: bucket.credential.secret,
          currentBucket: bucket.credential.bucketName
        }
      });
    }
  }

  addStorage = (targetStorage) => {
    if (!this.state[targetStorage].bucketName && !this.state[targetStorage].id && !this.state[targetStorage].secret) {
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          editOrgerrorMessage: getMessage("EMPTY_MESSAGE") 
        }
      });
    }
    else if (this.state[targetStorage].isVerified) {
      let bucket = this.state[targetStorage].storageDetails;
      bucket.type = bucket.type ? bucket.type : "S3";
      bucket.list = bucket.list ? bucket.list : [];
      bucket.location = this.state[targetStorage].storageDetails?.location;

      let isDuplicateStorageDetails =false;
      bucket.list.map((content, i) =>{
        if(content.credential.bucketName === this.state[targetStorage].bucketName
          && content.credential.id === this.state[targetStorage].id
          && content.credential.secret === this.state[targetStorage].secret) {
          //Duplicate Storage Details
          isDuplicateStorageDetails=true;
        }
      });

      if(!isDuplicateStorageDetails) {
        if (!this.state[targetStorage].isEditStorage) {
          let cred = {
            credential: {
              bucketName: this.state[targetStorage].bucketName,
              id: this.state[targetStorage].id,
              secret: this.state[targetStorage].secret
            },
            validation: { status: true },
            isSelected: this.state[targetStorage].isSelected,
            id: null
          };
          bucket.list.push(cred);
        }
        else {
          let cred = {
              bucketName: this.state[targetStorage].bucketName,
              id: this.state[targetStorage].id,
              secret: this.state[targetStorage].secret
            },
            validation = { status: true }
          bucket.list = bucket.list.map((content, i) => 
            content.credential.bucketName === this.state[targetStorage].bucketName ? {
              ...content, credential: cred, validation: validation
            } : content)
        }
        this.resetStorageDetailsFields(targetStorage);
        this.setState((state, props) => {
          return{
            [targetStorage]: {
              ...state[targetStorage],
              storageDetails: bucket,
              isDataEdited: true             
            }
          }
        })
      }
      else {
        this.setState({
          [targetStorage]: {
            ...this.state[targetStorage],
            editOrgerrorMessage: getMessage("DUPLICATE_STORAGE_CREDENTIALS")
          }
        });
      }
    }
    else {
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          editOrgerrorMessage: getMessage("BEFORE_VERIFICATION_ERROR")
        }
      });
    }
  }

  handleVerifyStorageDetailsClick = (targetStorage) => {
    this.resetError(targetStorage);
    if (this.state[targetStorage].bucketName 
      && this.state[targetStorage].id && this.state[targetStorage].secret) {
      this.setState({ spinnerVisibility: true });
      let storage = {
        type: 'S3',
        credentials: {
          id: this.state[targetStorage].id,
          secret: this.state[targetStorage].secret,
          bucketName: this.state[targetStorage].bucketName
        }
      }
      this.props.verifyStorage(storage, (error) => {
        if (error.code)
          this.setState({ 
            spinnerVisibility: false,
            [targetStorage]: {
              ...this.state[targetStorage],
              isVerified: false, 
              storageErrorMessage: getMessage(error.code) 
            }
          })
        else {
          this.setState({
            spinnerVisibility: false,
            [targetStorage]: {
              ...this.state[targetStorage],
              isVerified: true,
              storageErrorMessage: "" 
            }
          })
        }
      })
    }
    else {
      this.setState({
        [targetStorage]: {
          ...this.state[targetStorage],
          storageErrorMessage: getMessage("EMPTY_MESSAGE") 
        }
      });
    }
  }

  onChangeStorageOption = (event, targetStorage) => {
    let selectedStorage = event.target.value;
    this.resetStorageDetailsFields(targetStorage);
    this.resetError(targetStorage);
    this.setState((state, props) => {
      let obj = state[targetStorage].storageDetails ? state[targetStorage].storageDetails : {};
      if (obj) {
        obj.location = selectedStorage == "Select" ? null : selectedStorage;
        obj.list = obj.list ? obj.list : [];
        return{
          [targetStorage]: {
            ...state[targetStorage],
            storageDetails: obj
          },
          isDataEdited: true
        }
      }
    });
  }
  
  cancelStorage = (targetStorage) => {
    this.resetStorageDetailsFields(targetStorage);
    this.resetError(targetStorage);
  }
  isOutsideRange=(day)=>{
    //
    let dayIsBlocked = false;
    //Block past dates
    //if(moment(this.state.previousDate).add(1,'days').diff(day, 'days') > 0) {
    if(getTomorrowDate().diff(day.startOf('day'), 'days') > 0) {
      dayIsBlocked = true;
    }
    
    return dayIsBlocked;
  }

  handleSwitches=(toggleFlag,variable)=>{
    // && variable !== "RECORDING" を追加
    if(variable !== "ALLOW_DOWNLOAD" && variable !== "PDF" && variable !== "RECORDING" && variable !== "SUPPORT_CENTER"){ 
      this.setState((prevState) => ({ [variable]: !prevState[variable] ,isDataEdited:true}));
      if (variable =="isSSOEnabled" && this.state.isMfaEnabled) {
        this.handleMfaSwitches(false)
      }  
    }
    else{
      let state_element = this.state.availableModules;
      if (toggleFlag && !(variable in state_element)) {
 
        state_element.push(variable);
      } else if (!toggleFlag) {
        state_element = _.remove(state_element, item => {
          if (item !== variable) return item;
        });
      }
      this.setState({ availableModules: state_element, errorMessage: "" ,isDataEdited:true});
    }
  }
 
  renderSwitch = (flag,variable)=>{
    return (
      <Switch
        switchOn={flag}
        toggleSwitch={(event)=>{this.handleSwitches(event,variable)}}
        className="modal-label"
      />
    )
  }

  renderMfaSwitch = (flag)=>{
    return (
      <Switch
        switchOn={flag}
        toggleSwitch={(event)=>{this.handleMfaSwitches(event)}}
        className="modal-label"
      />
    )
  }

  renderNoOfSeats = () => {
    return (
      <FormGroup>
        <Label className="label modal-label">{getMessage("NO_OF_SEATS_LIMIT")}</Label>
        <NumericInput
          name="seats"
          className="ml-1 inputFormControl"
          min={0}
          value={this.state.seats}
          strict={false}
          precision={0}
          onChange={(value) => this.handleNumberInputChange("seats", value, 999999)}
          onKeyDown={this.handleNumericKeyDown}
          required
        />
      </FormGroup>
    );
  }

  renderMaxConcurrentConnections = () => {
    return (
      <FormGroup>
        <Label className="label modal-label">{getMessage("MAX_CONCURRENT_CONNECTIONS_LABEL")}</Label>
        <NumericInput
          name="maxConcurrentConnections"
          className="ml-1 inputFormControl"
          min={0}
          value={this.state.maxConcurrentConnections}
          strict={false}
          precision={0}
          onChange={(value) => this.handleNumberInputChange("maxConcurrentConnections", value, 9999999)}
          onKeyDown={this.handleNumericKeyDown}
          required 
        />
      </FormGroup>
    );
  }

  handleMfaSwitches=(toggleFlag)=>{
    for(let i=0; i<this.state.availableModules.length; i++){
      if(this.state.availableModules[i] == 'MFA'){
        this.state.availableModules.splice(i, 1);
      }
    }
    if (toggleFlag) {
      this.state.availableModules.push('MFA')
      if (this.state.isSSOEnabled){
        this.handleSwitches(false,"isSSOEnabled")
      }  
    }
    this.setState({
      isMfaEnabled: toggleFlag
    })
    this.setState({isDataEdited: true})
  }
 
  getSystemCapacity = () => {
    return (this.props.sessionsCapacity.systemMaxCapacity - this.props.sessionsCapacity.usedCapacity);
  }

  displaySystemCapacityUI = () => {
    return (
      <Col xs={3} className="d-flex modal-label">
        <span  className="p-0 modal-label systemCapacityLabel"> {getMessage("SYSTEM_CAPACITY")}: </span>
        <span className="modal-label ml-1 systemCapacityValue"> {this.getSystemCapacity()}</span>
      </Col>
    )
  }

  showOrHideSystemCapacity = (showSystemCapacity) =>{
    this.setState({
      showSystemCapacity: showSystemCapacity,
    });
  }
 
  render() {
    return (
      <div>
        {this.renderSpinner()}
        <div
          className="addOrganisationModal p-3 whiteBackground"
          backdrop="static"
        >
          <Form className="editModal">
            <FormGroup className="OrgLogoForm">
              <Label className="label modal-label">{getMessage("ORGANIZATION_LOGO")}</Label>
              <Row className="flex5" disabled>
                <Col md="6" className="OrganizationLogo">
                  {this.state.logo ? (
                    <img className="OrganizationLogoImg" src={this.state.logo} />
                  ) : null}
                </Col>
                <Col md="3" className="uploadImgDivCss">
                  <Button
                    alt="upload_img"
                    className="cursorPointer uploadbtnCss"
                    onClick={this.handleUploadImage}
                  >
                    {getMessage("UPLOAD_PROFILE_IMG")}
                  </Button>
                  <input
                    type="file"
                    accept=".jpg,.jpeg,image/png,image/gif"
                    onChange={event => {
                      this.handleOrgLogoChange(event);
                      event.target.value = null;
                    }}
                    className="inputFile displayNone"
                    id="uploadImage"
                    ref={ref => this.uploadImageRef = ref}
                  />
                </Col>
              </Row>
            </FormGroup>
            <div className="display-none">
              <Label className="label modal-label">{getMessage("WORDING_DEFINITION")}</Label>
              <Row className="flex5" disabled>
                <Col xs={5} className="uploadImgDivCss pr-0">
                  {this.state.tenantWording_data ?
                    <Button
                      alt="upload_img"
                      className="cursorPointer translationUploadbtnCss"
                      onClick={this.handleUploadOrgWording}
                    >
                      <span className="customButtonOn">
                        <div className="selectedCheck"></div>
                        <span>{getMessage("CUSTOMIZATION_SPECIFIED")}</span>
                      </span>
                    </Button>
                    :<Button
                      alt="upload_img"
                      className="cursorPointer translationUploadbtnCss"
                      onClick={this.handleUploadOrgWording}
                    >
                      <span>{getMessage("SPECIFY_CUSTOMIZATION")}</span>
                    </Button>}
                  <input
                    type="file"
                    onChange={event => {
                      this.handleOrgWordingChange(event);
                      event.target.value = null;
                    }}
                    id = "uploadTenantWording"
                    className="inputFile displayNone"
                    ref={ref => this.uploadWordingRef = ref}
                  />
                </Col>
                <Col xs={6} className="uploadImgDivCss">
                  {this.props.translation ?
                    <Button
                      className="translationUploadbtnCss cursorPointer"
                      onClick={this.downloadOrgWording}
                    >
                      <a
                        id="downloadWordingFile"
                        className="downloadWording"
                      >
                        <span className="downloadButton">
                          {getMessage("DOWNLOAD_CUSTOMIZATION")}
                        </span>
                        <img
                          className="downloadIcon"
                          src={download_img}
                        />
                      </a>
                    </Button>
                    :<Button
                      className="cursorDisabled translationUploadbtnCssDisable"
                      disabled
                    >
                      <span className="downloadButton">
                        {getMessage("DOWNLOAD_CUSTOMIZATION")}
                      </span>
                      <img
                        className="downloadIcon"
                        src={download_img}
                        title={getMessage("DOWNLOAD")}
                      />
                    </Button>
                  } 
                </Col>
              </Row>
            </div>
            <DropdownItem divider className="divider" />
            <FormGroup >
              <Label className="label modal-label">
                {getMessage("ORGANIZATION_NAME")}
              </Label>
              <Input
                type="text"
                name="name"
                onChange={this.handleInputChange}
                className="inputFormControl"
                value={this.state.name}
                maxLength="100"
                required
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("BUSINESS_MODELS")}</Label>
              <Input
                type="select"
                name="businessModel"
                id="businessModel"
                className="inputFormControl cursorDisabled"
                onChange={this.handleInputChange}
                value={this.state.businessModel}
                disabled
              >
                <option className="inputFormControl" value={BUSINESS_MODELS.NUMBER_OF_SEATS}>{getMessage("NO_OF_SEATS")}</option>
                <option className="inputFormControl" value={BUSINESS_MODELS.MAX_CONCURRENT_CONNECTIONS}>{getMessage("MAX_CONCURRENT_CONNECTIONS")}</option>
              </Input>
            </FormGroup>

            {
              this.state.businessModel === BUSINESS_MODELS.NUMBER_OF_SEATS 
                ? this.renderNoOfSeats()
                : this.renderMaxConcurrentConnections()
            }

            <FormGroup>
              <Label className="label modal-label">{getMessage("ORGANIZATION_URI_IDENTIFIER")}</Label>
              <Input
                type="text"
                maxLength="50"
                name="uriIdentifier"
                className="inputFormControl"
                placeholder={getMessage("ORGANIZATION_URI_IDENTIFIER")}
                onChange={this.handleInputChange}
                value={this.state.uriIdentifier}
                required
              />
            </FormGroup>
            <Row>
              <Col xs={4} className="pr-0"> 
                <Label className="label modal-label p-0" style={{ alignSelf: "flex-start" }}> {getMessage("AVAILABLE_FEATURE")}</Label>
              </Col>
              <Col xs={3} className="d-flex noPadding modal-label">
                <Label className="label modal-label p-0"> {getMessage("SINGLE_SIGN_ON")}</Label>
                {this.renderSwitch(this.state.isSSOEnabled,"isSSOEnabled")}
              </Col>
              <Col xs={3} className="ml-5 d-flex modal-label">
                <Label className="label modal-label p-0 mr-5"> {getMessage("SPECIFIED_MEETING_CODE")}</Label>
                {this.renderSwitch(this.state.isPasscodeEnabled,"isPasscodeEnabled")}
              </Col>
            </Row>
            {/* PDF Editor toggle hidden (PDFTron removed, no replacement yet); SMS/MFA reflowed up to fill the slot. */}
            <Row>
              <Col xs={4} className="pr-0"></Col>
              <Col xs={3} className="d-flex noPadding modal-label">
                <Label className="label modal-label p-0"> {getMessage("ORGANIZATION_TEMPLATE")}</Label>
                {this.renderSwitch(this.state.isOrganizationTemplatesEnabled,"isOrganizationTemplatesEnabled")}
              </Col>
              <Col xs={3} className="ml-5 d-flex modal-label">
                <Label className="label modal-label p-0 mr-5"> {getMessage("ALLOW_SMS")}</Label>
                {this.renderSwitch(this.state.isSMSEnabled,"isSMSEnabled")}
              </Col>
            </Row>
            <Row>
              <Col xs={4} className="pr-0"></Col>
              <Col xs={3} className="d-flex noPadding modal-label">
                <Label className="label modal-label p-0"> {getMessage("ALLOW_DOWNLOAD")}</Label>
                {this.renderSwitch(this.state.availableModules && this.state.availableModules.includes("ALLOW_DOWNLOAD"),"ALLOW_DOWNLOAD")}
              </Col>
              <Col xs={3} className="ml-5 d-flex modal-label">
                <Label className="label modal-label p-0 mr-5"> {getMessage("MFA")}</Label>
                {this.renderMfaSwitch(this.state.isMfaEnabled)}
              </Col>
            </Row>
            <Row>
              <Col xs={4} className="pr-0"></Col>
              <Col xs={3} className="d-flex noPadding modal-label">
                <Label className="label modal-label p-0"> {getMessage("AUDIO_VIDEO_RECORDING")}</Label>
                {this.renderSwitch(this.state.availableModules && this.state.availableModules.includes("RECORDING"),"RECORDING")}
              </Col>
            </Row>

            <Row>
              <Col xs={4} className="pr-0"></Col>
              <Col xs={3} className="d-flex noPadding modal-label">
                <Label className="label modal-label p-0"> {getMessage("SUPPORT_CENTER")}</Label>
                {this.renderSwitch(this.state.availableModules && this.state.availableModules.includes("SUPPORT_CENTER"),"SUPPORT_CENTER")}
              </Col>
            </Row>

            <FormGroup >
              <Label className="label modal-label" style={{ alignSelf: "flex-start" }}>
                {getMessage("AVAILABLE_MODULE")}
              </Label>
              <Row className="flex5 ml-3">
                {this.displayAllModuleList()}
              </Row>
            </FormGroup>
            {
              this.state.availableModules.indexOf("QR_CODE") !== -1 ?
                <FormGroup>
                  <Label className="label modal-label">{getMessage("QR_CODE_LIMIT")}</Label>
                  <NumericInput
                    name="qr_limit"
                    value={this.state.qr_limit}
                    min={0}
                    strict={this.state.qr_limit <= 10}
                    onChange={(value) => this.handleNumberInputChange("qr_limit", value, 10)}
                    className="ml-1 inputFormControl"
                    required
                  />
                </FormGroup> : null
            }
            <FormGroup >
              <Label className="label modal-label">{getMessage("EXPIRY_DATE")}</Label>
              <div className="col-9 pl-4 pr-0">
                <SingleDatePicker
                  date={this.state.licenseExpiryDate} 
                  onDateChange={this.handleDateChange} 
                  focused={this.state.focused}
                  onFocusChange={({ focused }) => this.setState({ focused })} 
                  numberOfMonths={1}
                  id="licenseExpiryDate"
                  showDefaultInputIcon={false}
                  displayFormat="YYYY/MM/DD"
                  monthFormat={getMessage("DATE_PICKER_FORMAT")}
                  verticalSpacing={0}
                  isOutsideRange={this.isOutsideRange}
                  block noBorder hideKeyboardShortcutsPanel
                />
              </div>
              <div>{this.props.licenseExpiryDate}</div>
            </FormGroup>

            <FormGroup>
              <Label className="label modal-label">{getMessage("LOGGING_LEVEL")}</Label>
              <Input
                type="select"
                name="loggingLevel"
                id="loggingLevel"
                className="inputFormControl"
                onChange={this.handleInputChange}
                value={this.state.loggingLevel}
              >
                <option className="inputFormControl" value={LOG_TYPE.BASIC}>{getMessage("LOG_TYPE_BASIC")}</option>
                <option className="inputFormControl" value={LOG_TYPE.ADVANCED}>{getMessage("LOG_TYPE_ADVANCED")}</option>
              </Input>
            </FormGroup>

            <FormGroup>
              <Label className="label modal-label">
                {getMessage("COBROWSE_LICENSE_KEY")}
              </Label>
              <Input
                type="text"
                name="coBrowseLicenseKey"
                onChange={this.handleInputChange}
                className="inputFormControl"
                maxLength="50"
                value={this.state.coBrowseLicenseKey}
              />
            </FormGroup>
            <FormGroup>
              <Label className="label modal-label">{getMessage("COBROWSE_ACCESS_TOKEN")}</Label>
              <textarea
                className="inputFormControl"
                id="coBrowsePrivateKey"
                name= "coBrowsePrivateKey"
                rows="5"
                onChange={this.handleInputChange}
                onPaste={this.handlePaste}
                value={this.state.coBrowsePrivateKey}
              />
	             </FormGroup>

            <FormGroup>
              <Label className="label modal-label">{getMessage("STORAGE_OPTION")}</Label>
              <Input
                type="select"
                name="storageLocation"
                id="storageLocation"
                className="inputFormControl"
                onChange={(event) => this.onChangeStorageOption(event, "storage")}
                value={this.state.storage.storageDetails?.location}
              >
                <option className="inputFormControl" >{getMessage("SELECTION")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.LOOOKIT_GLOBAL}>{getMessage("LOOOKIT_GLOBAL")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.LOOOKIT_CUSTOM}>{getMessage("LOOOKIT_CUSTOM")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.CUSTOMER}>{getMessage("CUSTOMER")}</option>
              </Input>
            </FormGroup>
            {this.renderStorageDetailSetting("storage")}
            <DropdownItem divider className="divider" />

            <FormGroup>
              <Label className="label modal-label">{getMessage("RECORDING_STORAGE_OPTION")}</Label>
              <Input
                type="select"
                name="storageLocation"
                id="storageLocation"
                className="inputFormControl"
                onChange={(event) => this.onChangeStorageOption(event, "recordingStorage")}
                value={this.state.recordingStorage.storageDetails?.location}
              >
                <option className="inputFormControl" >{getMessage("SELECTION")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.LOOOKIT_CUSTOM}>{getMessage("LOOOKIT_CUSTOM")}</option>
                <option className="inputFormControl" value={STORAGE_LOCATION.CUSTOMER}>{getMessage("CUSTOMER")}</option>
              </Input>
            </FormGroup>
            {this.renderStorageDetailSetting("recordingStorage")}
            <DropdownItem divider className="divider" />

            {this.props.editOrganisationData.admin ? <>
              <FormGroup  >
                <Label className="label modal-label">{getMessage("EMAIL")}</Label>
                <Input
                  type="email"
                  name="username"
                  onChange={this.handleInputChange}
                  className="inputFormControl"
                  value={this.props.editOrganisationData.admin.email}
                  maxLength="50"
                  required
                  disabled
                />
              </FormGroup>
              <FormGroup className="pt-0">
                <Label className="label modal-label">{getMessage("LAST_NAME")}</Label>
                <Input
                  type="text"
                  name="lastName"
                  onChange={this.handleInputChange}
                  className="inputFormControl"
                  value={this.props.editOrganisationData.admin.last_name}
                  maxLength="50"
                  required
                  disabled
                />
              </FormGroup>
              <FormGroup>
                <Label className="label modal-label">{getMessage("FIRST_NAME")}</Label>
                <Input
                  type="text"
                  name="firstName"
                  onChange={this.handleInputChange}
                  className="inputFormControl"
                  value={this.props.editOrganisationData.admin.first_name}
                  maxLength="50"
                  required
                  disabled
                />
              </FormGroup>
            </> : null}

            {this.state.errorMessage ? <div className="errors">{this.state.errorMessage}</div> : null}
          </Form>
          <Row className="permissionButtons">
            {this.renderButtons()}
          </Row>
        </div>
      </div>
    );
  }

  componentWillUnmount() {
    if (this.state.logo) {
      URL.revokeObjectURL(this.state.logo);
    }
  }
}

export default EditOrganization;
